import { render, staticRenderFns } from "./Dummy.vue?vue&type=template&id=2e0d437e&lang=pug"
import script from "./Dummy.vue?vue&type=script&lang=js"
export * from "./Dummy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports